<template>
    <b-card class="mb-3 note" :body-class="{'d-none': !opened}">
        <b-row slot="header">
            <b-col class="text-capitalize">
                <span>{{ note.type }}</span>
                <span class="text-muted small" v-if="!opened" >
                    <br />
                    <span v-text="preview"></span>
                </span>
            </b-col>
            <b-col class="text-right">
                <b-button-group>
                    <b-button variant="link"
                              v-if="opened"
                              size="sm"
                              class="px-1 py-0"
                              @click.prevent="close">
                        <v-icon icon="icon-content"/>
                    </b-button>
                    <b-button variant="link"
                              v-else
                              size="sm"
                              class="px-1 py-0"
                              @click.prevent="open">
                        <v-icon icon="icon-list"/>
                    </b-button>
                    <b-button variant="link"
                              size="sm"
                              class="px-1 py-0"
                              @click.prevent="remove">
                        <v-icon icon="bin"
                                class="text-danger"/>
                    </b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <component
            v-show="opened"
            ref="notes"
            :note="note"
            :is="component"/>
    </b-card>
</template>

<script>
    import ImageType from "./Types/Image"
    import NoteType from "./Types/Note"
    import ScriptureType from "./Types/Scripture"
    import events from './Events'
    import truncate from "../../../filters/truncate"
    import text from '../../../filters/text'

    export default {
        components: {ImageType, NoteType, ScriptureType},
        props: ['note', 'canMoveUp', 'canMoveDown'],
        data() {
            return {
                opened: true
            }
        },
        created(){
            events.$on('note:drag:start', this.close.bind(this))
            events.$on('note:drag:end', this.open.bind(this))
        },
        computed: {
            component() {
                return this.note.type + "-type"
            },
            preview() {
                return truncate(text(this.note.content))
            }
        },
        methods: {
            remove() {
                this.$emit('remove', this)
            },
            moveUp() {
                this.$emit('move:up', this)
            },
            moveDown() {
                this.$emit('move:down', this)
            },
            toggle() {
                if (this.opened) {
                    this.close()
                } else {
                    this.open()
                }
            },
            open() {
                this.opened = true
            },
            close() {
                this.opened = false
            }
        }
    }
</script>
